import React from "react";
import { RegionCard } from "../../../components/RegionCard/region-card";
import "./styles.scss";

const regions = ["Asia", "Europe", "Africa", "Latin America", "North America"];

interface RegionsListProps {
  onClick?: (region: string) => void;
  activeRegion?: string;
}

export const RegionsList = (props: RegionsListProps): JSX.Element => {
  const { onClick, activeRegion } = props;
  return (
    <div className="rl">
      {regions.map((region) => (
        <RegionCard
          region={region}
          shouldSetTeamCount
          key={region}
          onClick={onClick && (() => onClick(region))}
          isActive={region === activeRegion}
        />
      ))}
    </div>
  );
};
RegionsList.defaultProps = {
  activeRegion: undefined,
  onClick: () => {},
};
